import React from "react";
import { KeyListener } from "react-game-kit";

type DebounceableState = {
  //	pauseRequested?: boolean;
  //	paused?: boolean;
  //	unpauseRequested?: boolean,
  }


abstract class DebounceableComponent<Props, State> extends React.Component<Props, State> {
  protected keyListener: KeyListener;

  constructor(props:Props) {
		super(props);
    this.keyListener = new KeyListener();
  }
  
  debounce = (testCondition:boolean, key:number, onKeyRelease:DebounceableState, modeString = '') => {
    if (testCondition) {
      if (this.keyListener.isDown(key)) {
        // No. They are still holding it
        return true;
      }
      this.setState(onKeyRelease);
    }
    return false;
  };
}

export default DebounceableComponent